var _circle, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralLedger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#006C52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.68 22.68v-4.333H31.347v4.333a1.95 1.95 0 0 0 2.167 2.167h13a1.95 1.95 0 0 0 2.166-2.167Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.18,
    y: 33.514,
    width: 8.667,
    height: 8.667,
    rx: 2.167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.18 40.014h6.5a2.167 2.167 0 0 0 0-4.334h-6.5a2.167 2.167 0 1 0 0 4.334ZM48.68 48.68h-6.5a2.167 2.167 0 1 0 0 4.334h6.5a2.167 2.167 0 0 0 0-4.334Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.18,
    y: 46.514,
    width: 8.667,
    height: 8.667,
    rx: 2.167
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.18 18.347h-6.5v4.333a1.95 1.95 0 0 1-2.166 2.167h-13a1.95 1.95 0 0 1-2.167-2.167v-4.333h-6.5a1.95 1.95 0 0 0-2.167 2.167v39a1.95 1.95 0 0 0 2.167 2.166H55.18a1.95 1.95 0 0 0 2.167-2.166v-39a1.95 1.95 0 0 0-2.167-2.167Zm-26 17.333c0-1.196.97-2.166 2.167-2.166h4.333c1.197 0 2.167.97 2.167 2.166v4.334c0 1.196-.97 2.166-2.167 2.166h-4.333a2.167 2.167 0 0 1-2.167-2.166V35.68Zm2.167 10.834c-1.197 0-2.167.97-2.167 2.166v4.334c0 1.196.97 2.166 2.167 2.166h4.333c1.197 0 2.167-.97 2.167-2.166V48.68c0-1.196-.97-2.166-2.167-2.166h-4.333Zm17.333 6.5h-6.5a2.167 2.167 0 0 1 0-4.334h6.5a2.167 2.167 0 0 1 0 4.334Zm-6.5-13h6.5a2.167 2.167 0 0 0 0-4.334h-6.5a2.167 2.167 0 0 0 0 4.334Z",
    fill: "#006C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralLedger);
export default __webpack_public_path__ + "static/media/general-ledger.ba23845b.svg";
export { ForwardRef as ReactComponent };